<div class="h-100">
    <dx-data-grid
        [dataSource]="purchaseOrderItems"
        class="grid theme-dependent"
        [allowColumnResizing]="true"
        [focusedRowEnabled]="true"
        [allowColumnReordering]="true"
        [autoNavigateToFocusedRow]="false"
        [showBorders]="true"
        [remoteOperations]="false"
        [columnAutoWidth]="true"
        [wordWrapEnabled]="false"
        [stateStoring]="{ enabled: true, type: 'localStorage', storageKey: 'appointment-lines-grid-state', savingTimeout: 0 }"
        (onRowDblClick)="onRowDblClick($event)"
        (onExporting)="onExporting($event)"
        [customizeColumns]="customizeColumns"
        keyExpr="material"
        width="100%"
    >
        <dxo-scrolling [scrollByContent]="true"></dxo-scrolling>
        <dxo-paging [pageSize]="5"></dxo-paging>
        <dxo-pager [visible]="true" [displayMode]="'full'" [showPageSizeSelector]="true" [showInfo]="true" [showNavigationButtons]="true"></dxo-pager>
        <dxo-load-panel [showPane]="false"></dxo-load-panel>
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
        <dxo-search-panel [visible]="true" placeholder="Search"></dxo-search-panel>
        <dxo-export [enabled]="true" [formats]="['xlsx']"></dxo-export>
        <dxo-column-chooser height="340px" [enabled]="true" [mode]="'select'">
            <dxo-position my="right top" at="right bottom" of=".dx-datagrid-column-chooser-button"></dxo-position>
            <dxo-search [enabled]="true"></dxo-search>
            <dxo-selection [allowSelectAll]="true" [selectByClick]="true" [recursive]="true"></dxo-selection>
        </dxo-column-chooser>

        <dxo-toolbar>
            <dxi-item location="before"><div class="grid-header">Lines</div></dxi-item>
            <dxi-item location="after" locateInMenu="auto" showText="inMenu" widget="dxButton" [options]="{ text: 'Clear Filters', icon: 'fa-sharp fa-thin fa-filter-slash', onClick: clearFilters, stylingMode: 'text' }"></dxi-item>
            <dxi-item location="after" locateInMenu="auto" showText="inMenu" widget="dxButton" [options]="{ text: 'Reset', icon: 'restore', onClick: resetGrid, stylingMode: 'text' }"></dxi-item>
            <dxi-item location="after" locateInMenu="auto"><div class="separator"></div></dxi-item>
            <dxi-item name="columnChooserButton" locateInMenu="auto"></dxi-item>
            <dxi-item name="exportButton"></dxi-item>
        </dxo-toolbar>

        <dxi-column [dataField]="gridFieldName('purchasingDocument')" caption="PO"></dxi-column>
        <dxi-column [dataField]="gridFieldName('item')" caption="Item"></dxi-column>
        <dxi-column [dataField]="gridFieldName('material')" caption="Material"></dxi-column>
        <dxi-column [dataField]="gridFieldName('materialDescription')" caption="Material Description"></dxi-column>
        <dxi-column [dataField]="gridFieldName('materialType')" caption="Material Type"></dxi-column>
        <dxi-column [dataField]="gridFieldName('orderQuantity')" caption="Order Quantity" dataType="number"></dxi-column>
        <dxi-column [dataField]="gridFieldName('stillToBeDeliveredQty')" caption="Still to be delivered (qty)" dataType="number"></dxi-column>

        <dxi-column [dataField]="gridFieldName('committedQuantity')" caption="Committed Quantity" dataType="number" [visible]="false"></dxi-column>
        <dxi-column [dataField]="gridFieldName('grQuantityReceived')" caption="GR quantity received" dataType="number" [visible]="false"></dxi-column>
        <dxi-column [dataField]="gridFieldName('stillToBeInvoicedQty')" caption="Still to be invoiced (qty)" dataType="number" [visible]="false"></dxi-column>
        <dxi-column [dataField]="gridFieldName('goodsReceiptPostingDate')" caption="Goods Receipt Posting Date" dataType="date" [visible]="false"></dxi-column>

        <dxo-summary>
            <dxi-total-item [column]="gridFieldName('orderQuantity')" summaryType="sum" [customizeText]="customizeSum"></dxi-total-item>
            <dxi-total-item [column]="gridFieldName('stillToBeDeliveredQty')" summaryType="sum" [customizeText]="customizeSum"></dxi-total-item>
        </dxo-summary>
    </dx-data-grid>
</div>